import { Card } from "@/components/ui/card";
import { FadeIn } from "@/components/ui/motion";

export function LoadingState({ text = "Loading..." }: { text?: string }) {
  return (
    <FadeIn>
      <Card className="px-4 py-8 text-center text-sm text-muted">
        <span className="inline-flex items-center gap-2">
          <span className="h-2 w-2 animate-pulse rounded-full bg-brand-400" />
          {text}
        </span>
      </Card>
    </FadeIn>
  );
}
